export const Logos = {
  textLogo: require("assets/logo/text-logo.svg").ReactComponent,
  symbolLogo: require("assets/logo/symbol-logo.svg").ReactComponent,
  shadowLogo: require("assets/logo/shadow-logo.svg").ReactComponent,
  syncboxLogo: require("assets/logo/syncbox-logo.svg").ReactComponent,
};
